import {
  CustomerPortalPaymentMethod,
  PaymentMethodTypeEnum,
} from '@monetize/types/app';
import { MdAccountBalance } from 'react-icons/md';
import { MBox, MFlex, MIcon, MText } from '../../../../../components/Monetize';

interface PaymentMethodBankTransferProps {
  paymentMethod: CustomerPortalPaymentMethod;
}

export const PaymentMethodBankTransfer = ({
  paymentMethod,
}: PaymentMethodBankTransferProps) => {
  const {
    bankName,
    paymentMethodType,
    accountNumber,
    routingNumber,
    swiftCode,
  } = paymentMethod;

  if (
    paymentMethodType !== PaymentMethodTypeEnum.US_BANK_TRANSFER ||
    !routingNumber ||
    !accountNumber
  ) {
    return null;
  }

  return (
    <MFlex
      alignItems="center"
      gap={3}
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor="tGray.back"
      bg="white"
      transition="all 0.15s ease"
    >
      <MBox
        p={2}
        borderRadius="md"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <MIcon as={MdAccountBalance} color="tGray.darkPurple" boxSize={5} />
      </MBox>
      <MBox flex={1}>
        <MFlex flexDirection="column" justifyContent="space-between" mt={0.5}>
          <MText fontSize="xs" color="tGray.darkPurple">
            To pay via ACH, transfer funds using the following bank information:
          </MText>
          <MText fontSize="xs" color="tGray.darkPurple">
            <strong>Routing Number:</strong> {routingNumber}
          </MText>
          <MText fontSize="xs" color="tGray.darkPurple">
            <strong>Account Number:</strong> {accountNumber}
          </MText>
          {swiftCode && (
            <MText fontSize="xs" color="tGray.darkPurple">
              <strong>SWIFT Code:</strong> {swiftCode}
            </MText>
          )}
        </MFlex>
      </MBox>
    </MFlex>
  );
};
